import aaeLogo from './aae_logo.svg';
import campEagleLogo from './camp_eagle_logo.svg';
import qcsoLogo from './qsco_logo.svg';
import sameLogo from './same_logo.svg';
import unitedWayLogo from './united_way_logo.svg';

import aaeBackground from './aae_background.jpg';
import campEagleBackground from './camp_eagle_background.jpg';
import feathrIntelligenceBackground from './feathr_intelligence_background.jpg';
import feathrLogo from './feathr_logo.jpg';
import fundraisingPaysYouBackBackground from './fundraising_pays_you_back_background.jpg';
import qcsoBackground from './qsco_background.jpg';
import sameBackground from './same_background.jpg';
import unitedWayBackground from './united_way_background.jpg';

export const backgroundImages = {
  aae: aaeBackground,
  campEagle: campEagleBackground,
  feathrIntelligence: feathrIntelligenceBackground,
  qcso: qcsoBackground,
  same: sameBackground,
  unitedWay: unitedWayBackground,
  fundraisingPaysYouBack: fundraisingPaysYouBackBackground,
};

export const logos = {
  aae: aaeLogo,
  campEagle: campEagleLogo,
  feathr: feathrLogo,
  qcso: qcsoLogo,
  same: sameLogo,
  unitedWay: unitedWayLogo,
};
